import { useEffect } from "react";

const NUDGE_TITLE = "👋 Still there? — Coreshift";

/**
 * Swaps the tab title to a short nudge while the tab is hidden, and restores
 * whatever title was active when the user left (Helmet may have changed it
 * per-route) once they tab back in.
 */
export function useTabTitleNudge() {
  useEffect(() => {
    let previousTitle = document.title;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        previousTitle = document.title;
        document.title = NUDGE_TITLE;
      } else {
        document.title = previousTitle;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
}
